import { signOut } from '../../utils/cognitoAuth';
import { Link } from 'react-router-dom';
import React from 'react';
import { AdminToggle } from '../AdminToggle';
import useUser from '../../Hooks/useUser';
import { useTranslation } from 'react-i18next';

const mobileSignOut = async () => {
  await signOut();
  window.location.reload();
};

export const MobileMenuFooter = ({ setIsOpen }) => {
  const { currentUser, impersonateEmail } = useUser();
  const { t } = useTranslation();
  const showAdminToggle = impersonateEmail === '' && currentUser?.role === 'admin';

  return (
    <>
      <div className='position-sticky mb-4 block h-24 px-4 py-6'>
        {showAdminToggle && <AdminToggle fontSize={'text-3xl'} />}
      </div>
      <div className="flex justify-between">
        <Link
          to={`/profile/${currentUser._id}?q=account`}
          onClick={() => setIsOpen(false)}
          className="border-pddarkblue bg-pddarkblue text-pdwhite mx-3 inline-flex h-16 w-[50%] items-center justify-center gap-x-3 rounded rounded-md border-1 p-6 text-3xl font-semibold"
        >
          {t('My Profile')}
        </Link>
        <Link
          to=""
          onClick={mobileSignOut}
          className="border-pddarkblue bg-pdwhite text-pddarkblue mx-3 inline-flex h-16 w-[50%] items-center justify-center gap-x-3 rounded rounded-md border-1 p-6 text-3xl font-semibold"
        >
          {t('Logout')}
        </Link>
      </div>
    </>
  );
};
